// SETTINGS V2 — canonical base path (SETTINGS_V2_SP10 §3).
//
// Single source of truth for the v2 settings mount point. After the SP10 flip
// the v2 pages became the DEFAULT settings surface and render at /settings/* (the
// legacy MUI tree was retired). Every nav target, active-match, and in-dialog
// navigate() consumes this constant, so any future base change — or the §5
// rollback — is a one-line edit here instead of a scatter of literals.
export const SETTINGS_BASE = "/settings";
